import { render } from "./AnnouncementsList.vue?vue&type=template&id=d173d2de&scoped=true"
import script from "./AnnouncementsList.vue?vue&type=script&lang=js"
export * from "./AnnouncementsList.vue?vue&type=script&lang=js"

import "./AnnouncementsList.vue?vue&type=style&index=0&id=d173d2de&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d173d2de"]])

export default __exports__